import React from 'react';

export function DispatchToolbar({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative isolate flex h-full flex-col gap-y-2 p-4">
      {children}
    </div>
  );
}
